const state = {
  contact_us: [],
  contact_us_id: [],
  enable_disable_feature: [],
  enable_disable_feature_id: [],
  new_user: [],
  new_user_id: [],
};

export default state;
